import { StudioError } from '#~/error/index.js';
import { CalibrationActionType, calibrate } from './calibrate.js';
import type { Complement } from './types.js';

/**
 * Start device calibration.
 *
 * @param deviceId - Device ID.
 */
export const complement: Complement = async (deviceId) => {
  try {
    await calibrate(deviceId, CalibrationActionType.CALIBRATION_ACTION_COMPLEMENT);
  } catch (cause) {
    throw new StudioError('Unable to start device calibration.', { cause });
  }
};
